/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios";
import setNotification from '@/notification';

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (!error.response) {
            return Promise.reject(error);
        }
        let errorMsg = null;

        if (error.response.status == 422) {
            let errors = error.response.data.errors;
            errorMsg = errors[Object.keys(errors)[0]][0];
        } else if (error.response.status == 401) {
            window.location.href = '/login';
        } else if (error.response.status == 432) {
            // used in getConfig controller. Custom error code 432 used to don't show error message.
            errorMsg = '';
        } else {
            errorMsg = error.response.data.message;
        }
        let notification = {
            heading: 'Failed !',
            subHeading: errorMsg,
            type: "error",
        };
        setNotification(notification);
        return Promise.reject(error);
    }
);
window.axios = axios;
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const localization = document.documentElement.lang || 'en'; // Default to 'en' if not set
axios.defaults.headers.common['X-localization'] = localization;
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

import Pusher from "pusher-js";
window.Pusher = Pusher;

let echoConfig = {
    broadcaster: "pusher",
    wsHost: import.meta.env.VITE_PUSHER_HOST ||
         `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    wsPort: parseInt(import.meta.env.VITE_PUSHER_PORT || 80),
    wssPort: parseInt(import.meta.env.VITE_PUSHER_WSS_PORT || 443),

    forceTLS: false,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
};
// echoConfig['wsHost'] = window.location.hostname;

window.Echo = new Echo(echoConfig);
//

